import React from 'react';

const benefits = [
  {
    title: 'Equipo con Garantía',
    description:
      'Todos nuestros productos cuentan con respaldo oficial y soporte local para que compres sin preocupaciones.',
    icon: 'shield',
    aos: { animation: 'fade-up', delay: 0 },
  },
  {
    title: 'Pago 100% Seguro',
    description:
      'Procesamos tus pagos con encriptación de punta a punta y métodos confiables como tarjetas, Sinpe Móvil y financiamientos.',
    icon: 'lock',
    aos: { animation: 'fade-up', delay: 150 },
  },
  {
    title: 'Envío a Todo Costa Rica',
    description:
      'Entregamos en todo el territorio nacional con aliados logísticos confiables y seguimiento durante el envío.',
    icon: 'truck',
    aos: { animation: 'fade-up', delay: 300 },
  },
];

const iconComponents = {
  shield: (
    <svg className="benefit-icon" viewBox="0 0 72 72" role="img" aria-hidden="true">
      <path d="M36 8l24 10v14c0 16.6-10.5 26.7-24 32-13.5-5.3-24-15.4-24-32V18z" />
      <polyline points="24 36 32.5 44.5 48 28" />
    </svg>
  ),
  lock: (
    <svg className="benefit-icon" viewBox="0 0 72 72" role="img" aria-hidden="true">
      <rect x="16" y="32" width="40" height="30" rx="6" ry="6" />
      <path d="M24 32v-8c0-9 6-16 12-16s12 7 12 16v8" />
      <circle cx="36" cy="47" r="4.5" />
      <path d="M36 51.5V56" />
    </svg>
  ),
  truck: (
    <svg className="benefit-icon" viewBox="0 0 72 72" role="img" aria-hidden="true">
      <rect x="6" y="24" width="34" height="24" rx="4" ry="4" />
      <path d="M40 30h12l10 10v8H40z" />
      <circle cx="19" cy="54" r="6.5" />
      <circle cx="50" cy="54" r="6.5" />
      <path d="M12 24v-6h16" />
    </svg>
  ),
};

const PurchaseBenefits = () => (
  <section className="benefits-wrapper">
    <div className="benefits-inner">
      <div className="benefits-header" data-aos="fade-up">
        <h2>Confianza en cada compra</h2>
      </div>

      <div className="benefits-grid">
        {benefits.map((benefit) => (
          <article
            key={benefit.title}
            className="benefit-card"
            data-aos={benefit.aos.animation}
            data-aos-delay={benefit.aos.delay}
          >
            <div className="benefit-icon-wrap">
              <div className="benefit-icon-halo" />
              {iconComponents[benefit.icon]}
            </div>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default PurchaseBenefits;
